import $ from 'jquery';

function Toggle(el, opts = {}) {
    this.$toggle = $(el);
    this.$window = $(window);
    this.breakpoint = this.$toggle.data('toggle-breakpoint');
    this.$target = $( this.$toggle.data('target') );

    this.opts = Object.assign({
        toggleSpeed: 150,
        breakpoint: 768,
    }, opts);
}

Toggle.prototype.initListeners = function() {
    this.$toggle.click(this.clickHandler.bind(this));
};

Toggle.prototype.clickHandler = function(e) {
  e.preventDefault();

  // eslint-disable-next-line
  console.log('test');
    // eslint-disable-next-line
    console.log(this.$target);

    this.$target.slideToggle(this.opts.toggleSpeed);
    this.$toggle.toggleClass('active');
};

Toggle.prototype.reset = function() {
    this.$target.prop('style', false);

    this.$toggle.removeClass('active');
};

export default Toggle;



// WEBPACK FOOTER //
// ./scripts/components/Toggle.js